import { render, staticRenderFns } from "./NotificationEditLink.vue?vue&type=template&id=24539cbf"
import script from "./NotificationEditLink.vue?vue&type=script&lang=js"
export * from "./NotificationEditLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports